import NttsTagList from '../../../../utility/commonComponents/NttsTagList'
import { EmptyValue } from '../../../../utility/commonComponents/NttsTable'

// Truncated text gets the NttsTable tooltip automatically (ntts-ellipsis)
export const columns = [
  {
    sortable: false,
    minWidth: '220px',
    grow: 1,
    name: 'Mentor Name',
    cell: ({ mentorName }) =>
      mentorName ? (
        <span className="mm-name ntts-ellipsis">{mentorName}</span>
      ) : (
        <EmptyValue />
      ),
    selector: (row) => row?.mentorName
  },

  {
    sortable: false,
    minWidth: '320px',
    grow: 1,
    name: 'Technology Name',
    cell: ({ technologyName }) => (
      <NttsTagList value={technologyName} max={4} />
    ),
    selector: (row) => row?.technologyName
  }
]
